import React, { useEffect, useState } from "react";
import { api, errMsg, fmtDay } from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const ROLES = ["admin", "executive", "procurement", "finance", "sales", "operations", "inventory", "logistics", "compliance", "auditor"];

export default function AdminUsers() {
  const [users, setUsers] = useState(null);
  const load = () => api.get("/admin/users").then(({ data }) => setUsers(data)).catch(() => setUsers([]));
  useEffect(() => { load(); }, []);

  const changeRole = async (uid, role) => {
    try { await api.patch(`/admin/users/${uid}/role`, { role }); toast.success("Role updated"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  if (!users) return <div className="py-20 text-center text-slate-400"><Loader2 className="h-6 w-6 animate-spin inline" /></div>;
  return (
    <div>
      <div className="mb-5">
        <h1 className="font-head text-2xl font-bold tracking-tight text-slate-900">Users & Roles</h1>
        <p className="text-sm text-slate-500 mt-0.5">Role-based access control · segregation of duties matrix.</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <Table className="pf-table">
            <TableHeader>
              <TableRow className="bg-slate-50 hover:bg-slate-50">
                {["Name", "Email", "Auth", "Joined", "Role"].map((h) => (
                  <TableHead key={h} className="text-[11px] uppercase tracking-wide text-slate-500 font-semibold py-2.5 px-3">{h}</TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {users.map((u) => (
                <TableRow key={u.user_id} className="border-slate-100" data-testid={`user-row-${u.user_id}`}>
                  <TableCell className="py-2 px-3 text-[13px] font-medium text-slate-800">{u.name}</TableCell>
                  <TableCell className="py-2 px-3 text-xs text-slate-600">{u.email}</TableCell>
                  <TableCell className="py-2 px-3"><StatusBadge status={u.auth === "google" ? "Info" : u.auth} /></TableCell>
                  <TableCell className="py-2 px-3 text-xs text-slate-500">{fmtDay(u.created_at)}</TableCell>
                  <TableCell className="py-2 px-3 w-44">
                    <Select value={u.role} onValueChange={(v) => changeRole(u.user_id, v)}>
                      <SelectTrigger data-testid={`role-select-${u.user_id}`} className="h-8 text-xs"><SelectValue /></SelectTrigger>
                      <SelectContent className="bg-white z-[60]">
                        {ROLES.map((r) => <SelectItem key={r} value={r} className="capitalize">{r}</SelectItem>)}
                      </SelectContent>
                    </Select>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
